export default {"src":"/_next/static/media/pointer-icon.b0bc1ea4.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};